













































































































































































































import { Vue, Component } from 'vue-property-decorator'
import ListaDeLojas from '@/components/usuario/ListaDeLojas.vue'
import SeletorDeLojasDoUsuario from '@/components/loja/SeletorDeLojasDoUsuario.vue'
import {
	getMargemBruta, DreMargemBruta,
	getDespesasFixasMensal, listarDespesasFixas, criarDespesaFixa, definirVigencia, excluirDespesaFixa,
	getDespesasVariaveisMensal, DespesaFixa, DespesaFixaMensal, DespesaVariavelMensal,
} from '@/api/dre'
import { formatarMoeda } from '@/shareds/formatadores'
import { primaryColor } from '@/plugins/vuetify'
import moment from 'moment'

@Component({ components: { ListaDeLojas, SeletorDeLojasDoUsuario } })
export default class TelaDeDre extends Vue {
	lojaId: string | null = null
	mesInicio = moment().startOf('year').format('YYYY-MM') // DRE do exercício vigente (desde janeiro)
	mesFim = moment().format('YYYY-MM')
	carregando = false
	buscou = false
	erro = ''
	linhas: DreMargemBruta[] = []
	consolidado: DreMargemBruta | null = null
	despesasMensais: DespesaFixaMensal[] = []
	despesasVariaveis: DespesaVariavelMensal[] = []

	dialogoDespesas = false
	despesasFixas: DespesaFixa[] = []
	salvando = false
	nova: any = { lojaId: null, grupo: 'Ocupação', descricao: '', valor: null, mesInicio: moment().format('YYYY-MM') }
	vigenciaDe: DespesaFixa | null = null
	vig: any = { valor: null, mesInicio: moment().format('YYYY-MM') }
	gruposSugeridos = ['Ocupação', 'Pessoal', 'Comercial', 'Administrativas', 'Financeiras', 'Outras']

	headers = [
		{ text: 'Loja', value: 'loja' },
		{ text: 'Competência', value: 'competencia' },
		{ text: 'Receita Líq.', value: 'receitaLiquida', align: 'end' },
		{ text: 'Impostos', value: 'impostos', align: 'end' },
		{ text: 'CMV', value: 'cmv', align: 'end' },
		{ text: 'Lucro Bruto', value: 'lucroBruto', align: 'end' },
		{ text: 'Margem', value: 'margemPct', align: 'end' },
		{ text: 'Desp. Fixas', value: 'despesaFixa', align: 'end', sortable: false },
		{ text: 'Desp. Var.', value: 'despesaVariavel', align: 'end', sortable: false },
		{ text: 'Resultado', value: 'resultado', align: 'end', sortable: false },
	]
	headersDespesas = [
		{ text: 'Loja', value: 'loja' },
		{ text: 'Grupo', value: 'grupo' },
		{ text: 'Descrição', value: 'descricao' },
		{ text: 'Vigências', value: 'vigencias', sortable: false },
		{ text: '', value: 'acoes', sortable: false, align: 'end' },
	]

	created() { /* aguarda o usuário escolher a loja (DRE é por empresa) */ }

	get primaryColorHex(): string { return primaryColor() }

	// Consolidado seguro (zera quando não há margem, p/ lojas só com despesa aparecerem)
	get consolidadoExibido(): DreMargemBruta {
		return this.consolidado || ({
			contaId: '', lojaId: '', loja: 'Consolidado', competencia: null,
			receitaBruta: 0, descontos: 0, devolucoes: 0, receitaLiquida: 0, impostos: 0,
			cmv: 0, lucroBruto: 0, pecas: 0, margemPct: 0, pctVendaSemCusto: 0, pctVendaCustoFallback: 0,
		} as any)
	}

	// Linhas do DRE = margem ∪ lojas/meses que só têm despesa (aparecem com margem 0 e Resultado negativo)
	get linhasExibidas(): DreMargemBruta[] {
		const map: { [k: string]: DreMargemBruta } = {}
		const chave = (loja: string, comp: string) => loja + '|' + (comp || '').substring(0, 7)
		for (const l of this.linhas) map[chave(l.lojaId, l.competencia || '')] = l
		const addDespesa = (lojaId: string, loja: string, comp: string) => {
			const k = chave(lojaId, comp)
			if (!map[k]) map[k] = ({
				contaId: '', lojaId, loja, competencia: comp,
				receitaBruta: 0, descontos: 0, devolucoes: 0, receitaLiquida: 0, impostos: 0,
				cmv: 0, lucroBruto: 0, pecas: 0, margemPct: 0, pctVendaSemCusto: 0, pctVendaCustoFallback: 0,
			} as any)
		}
		this.despesasMensais.forEach(d => addDespesa(d.lojaId, d.loja, d.competencia))
		this.despesasVariaveis.forEach(d => addDespesa(d.lojaId, d.loja, d.competencia))
		return Object.keys(map).map(k => map[k])
			.sort((a, b) => (a.loja || '').localeCompare(b.loja || '') || (a.competencia || '').localeCompare(b.competencia || ''))
	}

	get kpis(): any[] {
		const c = this.consolidadoExibido
		if (!this.linhasExibidas.length) return []
		return [
			{ titulo: 'Receita Líquida', valor: this.moeda(c.receitaLiquida), icone: 'mdi-cash', cor: '#1E88E5', corFundo: 'blue lighten-5', corIcone: 'blue darken-1' },
			{ titulo: 'Lucro Bruto', valor: this.moeda(c.lucroBruto), icone: 'mdi-trending-up', cor: '#43A047', corFundo: 'green lighten-5', corIcone: 'green darken-1' },
			{ titulo: 'Despesas (fixas + variáveis)', valor: this.moeda(this.totalDespesas + this.totalDespVar), icone: 'mdi-cash-multiple', cor: '#E53935', corFundo: 'red lighten-5', corIcone: 'red darken-1' },
			{ titulo: 'Resultado', valor: this.moeda(this.resultadoConsolidado), icone: 'mdi-finance', cor: primaryColor(), corFundo: 'primary lighten-5', corIcone: 'primary' },
		]
	}

	// Modelo A: a despesa fixa (projeção) só conta no FUTURO; passado/atual usa o realizado (contas a pagar).
	get mesAtual(): string { return moment().format('YYYY-MM') }
	ehFuturo(comp: string | null): boolean { return (comp || '').substring(0, 7) > this.mesAtual }
	despesaFixaEfetiva(item: DreMargemBruta): number { return this.ehFuturo(item.competencia) ? this.despesaDe(item) : 0 }

	// Previsões (despesa fixa) em meses fechados/atuais SEM realização no contas a pagar → sinal de atenção.
	get projecoesSemRealizacao(): any[] {
		const temRealizado = new Set<string>()
		this.despesasVariaveis.forEach(d => temRealizado.add(d.lojaId + '|' + (d.competencia || '').substring(0, 7)))
		const alertas: any[] = []
		this.despesasMensais.forEach(d => {
			const comp = (d.competencia || '').substring(0, 7)
			if (comp <= this.mesAtual && !temRealizado.has(d.lojaId + '|' + comp)) {
				alertas.push({ competencia: comp, descricao: d.descricao, valor: d.valor })
			}
		})
		return alertas.sort((a, b) => a.competencia.localeCompare(b.competencia))
	}

	get totalDespesas(): number { return this.despesasMensais.filter(d => this.ehFuturo(d.competencia)).reduce((s, d) => s + (d.valor || 0), 0) }
	get totalDespVar(): number { return this.despesasVariaveis.reduce((s, d) => s + (d.valor || 0), 0) }
	get resultadoConsolidado(): number { return (this.consolidado ? this.consolidado.lucroBruto : 0) - this.totalDespesas - this.totalDespVar }

	// DRE clássico (vertical), consolidado da seleção
	get dreVertical(): any[] {
		const c = this.consolidadoExibido
		const abs = (v: number) => -Math.abs(v || 0)
		return [
			{ label: 'Receita Bruta de Vendas', valor: c.receitaBruta || 0, tipo: 'linha' },
			{ label: '(−) Descontos', valor: abs(c.descontos), tipo: 'deducao' },
			{ label: '(−) Devoluções', valor: c.devolucoes || 0, tipo: 'deducao' },
			{ label: '(=) Receita Líquida', valor: c.receitaLiquida || 0, tipo: 'subtotal' },
			{ label: '(−) Impostos sobre vendas', valor: abs(c.impostos), tipo: 'deducao' },
			{ label: '(−) CMV', valor: abs(c.cmv), tipo: 'deducao' },
			{ label: '(=) Lucro Bruto', valor: c.lucroBruto || 0, tipo: 'subtotal', extra: `${c.margemPct || 0}% de margem` },
			{ label: '(−) Despesas Fixas', valor: abs(this.totalDespesas), tipo: 'deducao' },
			{ label: '(−) Despesas Variáveis', valor: abs(this.totalDespVar), tipo: 'deducao' },
			{ label: '(=) Resultado Operacional', valor: this.resultadoConsolidado, tipo: 'resultado' },
		]
	}

	despesaDe(item: DreMargemBruta): number {
		const comp = (item.competencia || '').substring(0, 7)
		return this.despesasMensais
			.filter(d => d.lojaId === item.lojaId && (d.competencia || '').substring(0, 7) === comp)
			.reduce((s, d) => s + (d.valor || 0), 0)
	}
	despVarDe(item: DreMargemBruta): number {
		const comp = (item.competencia || '').substring(0, 7)
		return this.despesasVariaveis
			.filter(d => d.lojaId === item.lojaId && (d.competencia || '').substring(0, 7) === comp)
			.reduce((s, d) => s + (d.valor || 0), 0)
	}
	resultadoDe(item: DreMargemBruta): number { return (item.lucroBruto || 0) - this.despesaFixaEfetiva(item) - this.despVarDe(item) }

	async aplicar() {
		if (!this.lojaId) { this.erro = 'Selecione uma loja — o DRE é por empresa.'; this.buscou = false; return }
		if (!this.mesInicio || !this.mesFim) { this.erro = 'Informe o período.'; return }
		this.erro = ''
		this.carregando = true
		try {
			const lojasIds = [this.lojaId]
			const [resp, desp, dvar] = await Promise.all([
				getMargemBruta({ lojas: lojasIds, mesInicio: this.mesInicio, mesFim: this.mesFim }),
				getDespesasFixasMensal(this.mesInicio, this.mesFim, lojasIds),
				getDespesasVariaveisMensal(this.mesInicio, this.mesFim, lojasIds),
			])
			this.linhas = resp.linhas || []
			this.consolidado = resp.consolidado
			this.despesasMensais = desp || []
			this.despesasVariaveis = dvar || []
			this.buscou = true
		} catch (e: any) {
			this.erro = (e && e.mensagem) || (e && e.message) || 'Erro ao carregar o DRE.'
		} finally {
			this.carregando = false
		}
	}

	async abrirDespesas() {
		if (!this.lojaId) { this.erro = 'Selecione uma loja antes de gerenciar despesas fixas.'; return }
		this.dialogoDespesas = true
		await this.carregarDespesas()
	}
	async carregarDespesas() {
		try {
			this.despesasFixas = this.lojaId ? await listarDespesasFixas([this.lojaId]) : []
		} catch (e: any) { this.erro = (e && e.mensagem) || 'Erro ao listar despesas.' }
	}

	async salvarNova() {
		this.nova.lojaId = this.lojaId // despesa fixa é sempre da loja filtrada
		if (!this.nova.lojaId || !this.nova.descricao || !this.nova.valor || !this.nova.mesInicio) {
			this.erro = 'Preencha descrição, valor e mês da despesa.'; return
		}
		this.salvando = true
		try {
			await criarDespesaFixa({ ...this.nova })
			this.nova = { lojaId: null, grupo: 'Ocupação', descricao: '', valor: null, mesInicio: moment().format('YYYY-MM') }
			await this.carregarDespesas(); await this.aplicar()
		} catch (e: any) { this.erro = (e && e.mensagem) || 'Erro ao salvar despesa.' } finally { this.salvando = false }
	}

	abrirVigencia(d: DespesaFixa) {
		this.vigenciaDe = d
		this.vig = { valor: null, mesInicio: moment().format('YYYY-MM') }
	}
	async salvarVigencia() {
		if (!this.vigenciaDe || !this.vig.valor || !this.vig.mesInicio) return
		this.salvando = true
		try {
			await definirVigencia(this.vigenciaDe.id, { valor: this.vig.valor, mesInicio: this.vig.mesInicio })
			this.vigenciaDe = null
			await this.carregarDespesas(); await this.aplicar()
		} catch (e: any) { this.erro = (e && e.mensagem) || 'Erro ao salvar vigência.' } finally { this.salvando = false }
	}

	async excluir(d: DespesaFixa) {
		this.salvando = true
		try {
			await excluirDespesaFixa(d.id)
			await this.carregarDespesas(); await this.aplicar()
		} catch (e: any) { this.erro = (e && e.mensagem) || 'Erro ao excluir.' } finally { this.salvando = false }
	}

	moeda(v: number): string { return 'R$ ' + formatarMoeda(v == null ? 0 : v) }
	mes(competencia: string | null): string { return competencia ? moment(competencia).format('MM/YYYY') : '' }
	classeDre(l: any): string {
		if (l.tipo === 'resultado') return 'dre-resultado ' + (l.valor < 0 ? 'red--text' : 'green--text text--darken-2')
		if (l.tipo === 'subtotal') return 'dre-subtotal'
		return 'grey--text text--darken-2'
	}
}
